'use strict';

angular.module('shiftTraderApp')
  .service('MWPCompositeAvailabilityService', ['storage', '$rootScope', '$http', 'ServerUrls', '$q', '$timeout', 'AvailabilitySets', 'AvailabilityRules', '$log',
    function (storage, $rootScope, $http, ServerUrls, $q, $timeout, AvailabilitySets, AvailabilityRules, $log) {
      var cached = {
        time_off_rules: [],
        availability_sets: []
      };

      var currentMetadata = {
        start_date: null,
        end_date: null
      };

      var valid = false;
      var validUntil = null;

      var invalidateCache = function() {
        $log.debug('INVALIDATE CACHE');
        valid = false;
      };

      this.invalidateCache = function() {
        invalidateCache();
      };

      this.getCompositeAvailability = function(startMoment, endMoment) {
        $log.debug(moment.utc().format(), validUntil && validUntil.format());
        if (validUntil && moment.utc().isAfter(validUntil)) {
          $log.debug('setting VALID=FALSE because of validUntil > 30s');
          valid = false;
        }

        if (startMoment.isSame(currentMetadata.start_date) &&
          endMoment.isSame(currentMetadata.end_date) && valid) {
          $log.debug('getCompositeAvailability cache was VALID');
          var deferred = $q.defer();

          $timeout(function() {
            deferred.resolve(cached);
          });

          return deferred.promise;
        }

        $log.debug('getCompositeAvailability cache was INVALID');

        var data = {
          start_date: startMoment.toISOString()
        };

        if (endMoment) {
          data.end_date = endMoment.toISOString();
        }

        currentMetadata.start_date = startMoment;
        currentMetadata.end_date = endMoment ? endMoment : null;

        return $http.get(ServerUrls.current.railsApi + 'composite_availability', {
          params: data
        })
          .then(function(response) {
            if (startMoment.isSame(currentMetadata.start_date) &&
              endMoment.isSame(currentMetadata.end_date)) {
              valid = true;
              validUntil = moment.utc().add(30, 'seconds');
              $log.debug('setting valid and validUntil', validUntil.format());
            }

            cached.time_off_rules = _.map(response.data.time_off_rules, function(rule) {
              return AvailabilityRules.initWithData(rule);
            });
            cached.availability_sets = _.map(response.data.availability_sets, function(availSet) {
              return AvailabilitySets.initWithData(availSet);
            });
            return cached;
          }, function() {
            $log.debug('had an issue loading composite avail');
          });
      };

      $rootScope.$on('MWPCompositeAvailabilityService:invalidateCache', function() {
        invalidateCache();
      });
    }]);
